import { APIPath } from 'utility/constant'
import { BaseService } from './base'

class ActionPlanRuleServiceClass {
    getAssignedToTypes() {
        return BaseService.get(`${APIPath.actionPlanLookup}/AssignedToTypes`)
    }

    getPriorities() {
        return BaseService.get(`${APIPath.actionPlanLookup}/Priorities`)
    }

    getCategories() {
        return BaseService.get(`${APIPath.actionPlanLookup}/Categories`)
    }

    getTriggerOperators() {
        return BaseService.get(`${APIPath.actionPlanLookup}/TriggerOperators`)
    }

    getTeams() {
        return BaseService.get(APIPath.actionPlanTeams)
    }

    getLookupTeams() {
        return BaseService.get(`${APIPath.actionPlanLookup}/Teams`)
    }

    getVendorCompanies() {
        return BaseService.get(APIPath.actionPlanVendorCompanies)
    }

    getVendorContacts(vendorCompanyId) {
        return BaseService.get(
            APIPath.actionPlanVendorContacts(vendorCompanyId),
        )
    }

    createVendorCompany(data) {
        return BaseService.post(APIPath.actionPlanVendorCompany, data)
    }

    updateVendorCompany(vendorCompanyId, data) {
        return BaseService.put(
            APIPath.actionPlanVendorCompanyById(vendorCompanyId),
            data,
        )
    }

    deleteVendorCompany(vendorCompanyId) {
        return BaseService.remove(
            APIPath.actionPlanVendorCompanyById(vendorCompanyId),
        )
    }

    createVendorContact(data) {
        return BaseService.post(APIPath.actionPlanVendorContact, data)
    }

    updateVendorContact(vendorContactId, data) {
        return BaseService.put(
            APIPath.actionPlanVendorContactById(vendorContactId),
            data,
        )
    }

    deleteVendorContact(vendorContactId) {
        return BaseService.remove(
            APIPath.actionPlanVendorContactById(vendorContactId),
        )
    }

    getRuleCount(templateId) {
        return BaseService.get(APIPath.actionPlanRuleCount(templateId))
    }

    getRulesByTemplate(templateId) {
        return BaseService.get(APIPath.templateActionPlanRules(templateId))
    }

    getTicketsByTemplate(templateId) {
        return BaseService.get(APIPath.templateActionPlanTickets(templateId))
    }

    create(data) {
        return BaseService.post(APIPath.actionPlanRule, data)
    }

    update(ruleId, data) {
        return BaseService.put(`${APIPath.actionPlanRule}/${ruleId}`, data)
    }

    setEnabled(ruleId, isEnabled) {
        return BaseService.put(`${APIPath.actionPlanRule}/${ruleId}/Enabled`, {
            IsEnabled: isEnabled,
        })
    }

    remove(ruleId) {
        return BaseService.remove(`${APIPath.actionPlanRule}/${ruleId}`)
    }

    copyTo(ruleId, data) {
        return BaseService.post(
            `${APIPath.actionPlanRule}/${ruleId}/CopyTo`,
            data,
        )
    }

    bulkSave(templateId, rules) {
        return BaseService.post(
            APIPath.templateActionPlanRulesBulkSave(templateId),
            rules,
        )
    }
}

export const ActionPlanRuleService = new ActionPlanRuleServiceClass()
